import api from '../../api'

export const persist = async (wheels, homepageDomain, locationId) => {

	let axleWheelPref
	for (const wheel of wheels) {

		if (wheel.isCreate) {
			if (!axleWheelPref) {
				let resp = await api.service('localAccounts').find({
					query: {
						id: {
							$eq: locationId
						}
					}
				})
				axleWheelPref = resp.data[0].axleWheelPreferenceId

				if (!axleWheelPref) {
					const axleWheelResponse = await api.service('axleWheelPreferences').create({
						name: homepageDomain.profileName, 
					})

					axleWheelPref = axleWheelResponse.id
					await api.service('localAccounts').patch(locationId, {
						axleWheelPreferenceId: axleWheelPref
					})
				}
			}
			await api.service('axleWheelDetails').create({
				preferencesId: axleWheelPref,
				wheelTypeId: wheel.wheelType,
				color: wheel.colorFinish,
				wheelMaterialId: wheel.material,
				isErs: true,
				position: 1,
				wheelWidth: 1,
				comments: wheel.comments,
				wheelOffset: wheel.offset === -1 ? null : wheel.offset,
				wheelDiameterId: wheel.diameter,
				axleTypeId: 1,
			})
		} else if (wheel.isDelete) {
			await api.service('axleWheelDetails').remove(null, {
				query: {
					id: {
						$eq: wheel.id
					}
				}
			})
		} else if (wheel.isUpdate) {
			await api.service('axleWheelDetails').patch(wheel.id, {
				preferenceId: axleWheelPref,
				wheelTypeId: wheel.wheelType,
				color: wheel.colorFinish,
				wheelMaterialId: wheel.material,
				isErs: true,
				position: 1,
				wheelWidth: 1,
				comments: wheel.comments,
				wheelOffset: wheel.offset === -1 ? null : wheel.offset,
				wheelDiameterId: wheel.diameter,
				axleTypeId: 1,
			})
		}
	}



}


// WEBPACK FOOTER //
// ./src/database/lbb/wheelPreference.js